module.exports = __webpack_public_path__ + "img/x4.a13753f4.png";